<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header = "Información del Rubro">
          <b-table class="datos-objeto" responsive="sm" 
              :items="viaticoRubroDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
         
          <b-dropdown-item @click.stop="editar" v-if="accesoABM">
            <i class="fa fa-edit"></i>Editar Datos del Rubro</b-dropdown-item>
          <b-dropdown-divider v-if="accesoABM"></b-dropdown-divider>
          <b-dropdown-item @click.stop="goList">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'viaticoRubro/getField',
  mutationType: 'viaticoRubro/updateField',
});

export default {
  name: 'ViaticoRubroDatos',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      id: this.$route.params.id,  
      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],

      accesoABM: true
    }
  },
  computed: {
    ...mapFields([
      'viaticoRubroDatos',
    ])
  },
  created() {
    this.id= this.$route.params.id;

    this.showSpinner();
    this.$store.dispatch('viaticoRubro/getDatos', this.id)
      .catch( error => this.showErrorMsj (error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    goList() {
      this.$router.push({ name: "ViaticosRubros" });
    },
    editar() {
      if (this.accesoABM) {
        this.$router.push({ name: 'ViaticoRubroEdit', 
                            params: { id: this.id }});
      }
    }
  }
}
</script>
